import type { PlaidLinkOnSuccessMetadata } from 'react-plaid-link'

export const PLAID_ENV = import.meta.env.VITE_PLAID_ENV || 'sandbox'

export interface PlaidLinkSuccessData {
  publicToken: string
  metadata: PlaidLinkOnSuccessMetadata
}

export function getPlaidInstitutionInfo(metadata: PlaidLinkOnSuccessMetadata) {
  return {
    institutionId: metadata.institution?.institution_id ?? '',
    institutionName: metadata.institution?.name ?? 'Unknown Institution',
    accounts: metadata.accounts.map((account) => ({
      id: account.id,
      name: account.name,
      mask: account.mask ?? '',
      type: account.type as 'depository' | 'credit' | 'investment' | 'loan',
      subtype: account.subtype,
    })),
  }
}
